// extracted by mini-css-extract-plugin
export default {"spinner":"WP3d9iLhjad85gYG7Ehvf"};